import React from "react" 
import { Tooltip, IconButton } from "@material-ui/core";
import classNames from "classnames";
import dashboard from "../../../images/sidebar_icon/dashboard.png";
import hiringSupport from "../../../images/sidebar_icon/HiringSupport.png";
import regCompanies from "../../../images/sidebar_icon/regCompanies.png";
import companies from "../../../images/sidebar_icon/companies.png";
import priceList from "../../../images/sidebar_icon/pricelist.png";
import invoice from "../../../images/sidebar_icon/invoice.png";
import SidebarLink from "../components/SidebarLink/SidebarLink";
import useStyles from "../styles";

const SuperAdminSidebar = ({ location, isSidebarOpened }) => {
    const classes = useStyles();
    const superAdminItems = [
        {
            id: 0,
            label: "Dashboard",
            link: "/app/dashboard",
            view: true,
            icon: (
                <Tooltip title="Dashboard" placement="right">
                    <IconButton>
                        <img
                            src={dashboard}
                            alt="dashboard"
                            className={classNames(classes.Icon1)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 1,
            label: "Registered Companies",
            link: "/app/company",
            view: true,
            icon: (
                <Tooltip title="Registered Companies" placement="right">
                    <IconButton>
                        <img
                            src={regCompanies}
                            alt="transaction"
                            className={classNames(classes.Icon3)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 2,
            label: "Companies",
            link: "/app/admin",
            view: true,
            icon: (
                <Tooltip title="Companies" placement="right">
                    <IconButton>
                        <img
                            src={companies}
                            alt="companies"
                            className={classNames(classes.Icon2)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 3,
            label: "Plans",
            link: "/app/price",
            view: true,
            icon: (
                <Tooltip title="Plans" placement="right">
                    <IconButton>
                        <img
                            src={priceList}
                            alt="price"
                            className={classNames(classes.Icon3)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 4,
            label: "Transaction History",
            link: "/app/transaction",
            view: true,
            icon: (
                <Tooltip title="Transaction History" placement="right">
                    <IconButton>
                        <img
                            src={invoice}
                            alt="invoice"
                            className={classNames(classes.Icon4)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
        {
            id: 5,
            label: "Contact Sales",
            link: "/app/contact",
            view: true,
            icon: (
                <Tooltip title="Contact Sales" placement="right">
                    <IconButton>
                        <img
                            src={hiringSupport}
                            alt="transaction"
                            className={classNames(classes.Icon5)}
                        />
                    </IconButton>
                </Tooltip>
            ),
        },
    ];
    return (
        <>
            {
                superAdminItems.map((link) => (
                    <SidebarLink
                        key={link.id}
                        location={location}
                        isSidebarOpened={isSidebarOpened}
                        {...link}
                    />
                ))
            }
        </>
    );
}


export default SuperAdminSidebar;